<style lang="scss" scoped>
div {
  box-sizing: border-box;
}
.product-list-page {
  height: 100vh;
  padding-top: 180px;
  overflow: scroll;
  background-image: url('https://oss.turingsenseai.com/1623912866964426136.png');
  background-size: 100% 100%;

  .search-container {
    background-image: url('https://oss.turingsenseai.com/1623913475552458502.png');
    background-size: 100% 100%;
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 999;
    height: 120px;
    .input-wrap {
      width: 702px;
      height: 72px;
      box-sizing: border-box;
      border: 4px solid #000;
      border-radius: 4px;
      background-color: #f1f1f0;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 0 24px;
      margin: 24px auto;
      .search-input {
        flex: 1;
        margin-right: 20px;
        border: none;
        height: 64px;
        padding-left: 24px;
        background-color: #f1f1f0;
      }
      .search-icon {
        width: 36px;
        height: 36px;
        object-fit: contain;
      }
    }
  }
  .split-line {
    position: fixed;
    top: 120px;
    height: 18px;
    width: 100%;
    background-image: url('https://oss.turingsenseai.com/1623914645893707324.png');
    background-size: 100% 100%;
    z-index: 999;
  }

  .list-container {
    height: 100%;
  }

  .product-list {
    margin: 0 auto;
    width: 702px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    .product-item {
      margin-bottom: 18px;
      width: 344px;
      height: 530px;
      box-sizing: border-box;
      border: 4px solid #000;
      border-radius: 4px;
      background-color: #f1f1f0;
      overflow: hidden;
      .product-img {
        width: 344px;
        height: 344px;
        overflow: hidden;
        position: relative;
        .img {
          width: 100%;
          height: 100%;
          object-fit: cover
        }
        .sold-out {
          width: 140px;
          height: 140px;
          background-color: rgba($color: #000000, $alpha: 0.7);
          display: flex;
          justify-content: center;
          align-items: center;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translateX(-50%) translateY(-50%);
          color: #ffffff;
          font-size: 46px;
          border-radius: 50%;
        }
      }
      .msg-container {
        padding: 12 * 2px;
        box-sizing: border-box;
        .product-name {
          height: 34 * 2px;
          font-size: 26px;
          line-height: 34px;
          color: #2a2a30;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          line-clamp: 2;
          -webkit-line-clamp: 2;
        }
        .price {
          margin-top: 32px;
          color: #000;
          display: flex;
          .pre {
            font-size: 22px;
            line-height: 56px;
            margin-right: 4px;
          }
          .count {
            font-size: 34px;
            font-weight: 800;
          }
        }
      }
    }
  }
}
</style>

<template>
<div class="product-list-page">
  <div class="search-container">
    <div class="input-wrap">
      <input type="text" placeholder="搜索商品" class="search-input" v-model="searchWords"/>
      <img class="search-icon" @click="getProductList(true)" src="https://oss.turingsenseai.com/1623826683071669972.png"/>
    </div>
  </div>
  <div class="split-line"></div>
  <van-pull-refresh v-if="dataList.length > 0" v-model="refreshing" @refresh="getProductList(true)">
    <van-list
      class="list-container"
      v-model="loadingMore"
      :finished="finished"
      finished-text="没有更多了"
      @load="getProductList(false)">
      <div class="product-list">
        <div class="product-item" v-for="(product, index) in dataList" :key="index" @click="goDetail(product.pid)">
          <div class="product-img">
            <img class="img" :src="product.appearancePic" alt="">
            <div class="sold-out" v-if="product.status == 2">售罄</div>
          </div>
          <div class="msg-container">
            <div class="product-name">{{product.productName}}</div>
            <div class="price">
              <div class="pre">￥</div>
              <div class="count">{{product.price / 100}}</div>
            </div>
          </div>
        </div>
      </div>
    </van-list>
  </van-pull-refresh>
</div>
  
</template>

<script>
import { List, PullRefresh, Popup } from 'vant';
import { fetchProductList } from '../../../common/api/bag-show'
export default {
  components: {
    'van-list': List,
    'van-pull-refresh': PullRefresh,
    'van-popup': Popup,
  },
  data() {
    return {
      loadingMore: false,
      finished: false,
      refreshing: false,
      pageNum: 0,
      pageSize: 20,
      searchWords: '',
      dataList: [],
      businessId: '',
      loading: false,
    }
  },
  created() {
    const { businessId } = this.$route.params
    this.businessId = businessId
    this.getProductList(true)
  },
  methods: {
    getProductList(reset) {
      console.log('zzz')
      if (reset) {
        this.pageNum = 0
        this.finished = false;
      }
      if (this.finished || this.loading) return
      this.loading = true
      this.pageNum ++ ;
      fetchProductList({ pageNum: this.pageNum, pageSize: this.pageSize, businessId: this.businessId, productName: this.searchWords })
        .then(res => {
          if (res && res.errorCode == 0) {
            this.dataList = reset ? res.productList : [...this.dataList, ...res.productList]
            this.finished = res.isEnd
          }
        }).finally(() => {
          this.refreshing = false;
          this.loadingMore = false;
          this.loading = false
        })
    },
    search() {
      this.getProductList(true)
    },
    goDetail(pid) {
      this.$router.push({ path: `/bag-show/product-detail/${pid}`})
    }
  }
}
</script>